var SnazzyInfoWindow = require("snazzy-info-window");

$(document).ready(function() {

	var map;
	var url = window.location.origin;

	var markerSizeMD = 20;
	var markerSizeLG = 30;
	var markerSizeSM = 0;
	var animationTime = 200;
	var animationStepLength = 25;
	var animationSteps = animationTime/animationStepLength;


/* ==========================================================================
	Map Style
	========================================================================= */

	var styles =[{"stylers":[{"visibility":"on"},{"saturation":0},{"gamma":0.54}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"water","stylers":[{"color":"#4d4946"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"simplified"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"labels.text","stylers":[{"visibility":"simplified"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"gamma":0.48}]},{"featureType":"transit.station","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"gamma":7.18}]}];

	var styledMap = new google.maps.StyledMapType(styles, {
		name: "Styled Map"
	});

/* ==========================================================================
	Map Creation
	========================================================================= */

	window.render_map = function( $el ) {
		var $markers = $el.find('.marker');
		var args = {
			zoom		     : 15,
			center		     : new google.maps.LatLng(0, 0),
			mapTypeId        : google.maps.MapTypeId.ROADMAP,
			scrollwheel      : false,
			disableDefaultUI : false,
		};
		map = new google.maps.Map( $el[0], args);

		map.mapTypes.set('map_style', styledMap);
		map.setMapTypeId('map_style');

		map.markers = [];
		$markers.each(function() {
	    	add_marker($(this), map);
		});

		if ($(".filter-list").length) {
			filter = getActiveFilter();
			filter = filter.replace(/^\./, '');
			filterMarkers(filter);
		} else {
			center_map(map, map.markers);
		}
	}

	function add_marker($marker, map) {
		var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
		var terms = $marker.attr('data-terms');


		var marker = new google.maps.Marker({
			position: latlng,
			map: map,
			icon: {
				url: site_url + '/assets/img/parking_icon.png',
			},
			optimized: false,
			content: $marker.html(),
			animationIncrement: false
		});

		if (terms) {
			marker.terms = terms.split(" ");
		}

		marker.setOpacity(1);

		map.markers.push(marker);

		if ($marker.html()) {
			marker.window = new SnazzyInfoWindow({
				marker: marker,
				content: $marker.html(),
				// maxWidth: $marker.data("max-width") ? $marker.data("max-width") : 275,
				closeWhenOthersOpen: true,
				offset: {
					top: '-25px',
				}
			});
		}

		function maybeCloseInfoWindow() {
			if (marker.window.isOpen()) {
				marker.window.close();
			}
		}

		google.maps.event.addListener(marker, 'click', maybeCloseInfoWindow);
	}

	var markerLayer = new google.maps.OverlayView();
	markerLayer.draw = function() {
		this.getPanes().markerLayer.id = 'marker-layer';
	};
	markerLayer.setMap(map);

/* ======================================================================
	Center Map
	===================================================================== */

	function center_map(map, markers) {
		var bounds = new google.maps.LatLngBounds();

		$.each(markers, function(i, marker) {
			var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
			bounds.extend(latlng);
		});

		if (markers.length == 1) 	{
		    map.setCenter(bounds.getCenter());
		    map.setZoom( 15 );
		    markers[0].window.open();
		} else {
			map.fitBounds(bounds, 50);

			var listener = google.maps.event.addListener(map, "idle", function() {
				if (map.getZoom() > 15) {
					map.setZoom(15);
				}
				google.maps.event.removeListener(listener);
			});
		}
	}

/* ======================================================================
	Marker Animations
	===================================================================== */

	var markerOpacityIncrement = 0.2;

	var fadeInMarker = function(marker, callback) {
		var markerOpacity = marker.getOpacity();

	    if (markerOpacity < 1) {
	        markerOpacity += markerOpacityIncrement;
	        markerOpacity = (markerOpacity > 1) ? 1 : markerOpacity;

	        marker.setOpacity(markerOpacity);

	        setTimeout(function() {
	            fadeInMarker(marker, callback);
	        }, 50);
	    } else if (typeof callback === "function") {
	        callback(marker);
	    }
	}

	var fadeOutMarker = function(marker, callback) {
	    var markerOpacity = marker.getOpacity();

	    if (markerOpacity > 0) {
	        markerOpacity -= markerOpacityIncrement;
	        markerOpacity = (markerOpacity < 0) ? 0 : markerOpacity;

	        marker.setOpacity(markerOpacity);

	        setTimeout(function() {
	            fadeOutMarker(marker, callback);
	        }, 50);
	    } else if (typeof callback === "function") {
	        callback(marker);
	    }
	}

/* ======================================================================
	Scale Animations Part 2
	===================================================================== */

	var scaleInMarker = function(marker, callback) {
		var icon = marker.getIcon();

	    if (icon && icon.size.width < markerSizeMD) {
			if (marker.animationIncrement === false) {
				marker.animationIncrement = (markerSizeMD - icon.size.width)/animationSteps;
			}

	        if (icon.size.width + marker.animationIncrement <= markerSizeMD) {
				updateIconSize(marker, marker.animationIncrement);
	        }

	        setTimeout(function() {
	            scaleInMarker(marker, callback);
	        }, animationStepLength);
	    } else if (typeof callback === "function") {
	    	marker.animationIncrement = false;
	        callback(marker);
	    }
	}

	var scaleOutMarker = function(marker, callback) {
		var icon = marker.getIcon();

	    if (icon && icon.size.width > markerSizeSM) {
			if (marker.animationIncrement === false) {
				marker.animationIncrement = (markerSizeSM - icon.size.width)/animationSteps;
			}

	        if (icon.size.width + marker.animationIncrement >= markerSizeSM) {
				updateIconSize(marker, marker.animationIncrement);
	        }

	        setTimeout(function() {
	            scaleOutMarker(marker, callback);
	        }, animationStepLength);
	    } else if (typeof callback === "function") {
	    	marker.animationIncrement = false;

	        callback(marker);
	    }
	}

/* ======================================================================
	Scale Animations
	===================================================================== */

	var updateIconSize = function(marker, sizeChange) {
		var icon = marker.getIcon();
		var newSize = icon.size.width + sizeChange;

		icon.scaledSize = new google.maps.Size(newSize, newSize);
		icon.size = new google.maps.Size(newSize, newSize);

		marker.setIcon(icon);
		return marker;
	}

	var getMarkerIncrement = function(marker, newSize) {
		var icon = marker.getIcon();
		var difference = newSize - icon.size.width;
		return difference/animationSteps;
	}

	var scaleMarker = function(marker, increment) {
		if (increment > 0) { setMarkerVisible(marker); }

		var updateInterval = setInterval(updateIconSize.bind(null, marker, increment), animationStepLength);

		setTimeout(function() {
			clearInterval(updateInterval);
			if (increment < 0) { setMarkerInvisible(marker); }
		}, animationTime);
	}


	var scaleMarkerMD = function(marker) {
		var increment = getMarkerIncrement(marker, markerSizeMD);
		scaleMarker(marker, increment);
	}

	var scaleMarkerLG = function(marker) {
		var increment = getMarkerIncrement(marker, markerSizeLG);
		scaleMarker(marker, increment);
	}

	var scaleMarkerSM = function(marker) {
		var increment = getMarkerIncrement(marker, markerSizeSM);
		scaleMarker(marker, increment);
	}

/* ======================================================================
	Marker States
	===================================================================== */

	var setMarkerVisible = function(marker) {
		marker.setVisible(true);
	}

	var setMarkerInvisible = function(marker) {
		marker.setVisible(false);
	}

	var showMarkers = function(index, marker) {
		setMarkerVisible(marker);
		scaleInMarker(marker, setMarkerVisible);
	}

	var hideMarkers = function(index, marker) {
		scaleOutMarker(marker, setMarkerInvisible);
	}

/* ======================================================================
	Determine Show/Hide
	===================================================================== */

	var sortMarkers = function(filter) {
		var sorted = {
			toHide: [],
			toShow: [],
		};

		var sortMarkersArrays = function(index, marker) {
			if ($.inArray(filter, marker.terms) === -1) {
				sorted.toHide.push(marker);
			} else {
				sorted.toShow.push(marker);
			}
		};

		if (filter !== "*") {
			$.each(map.markers, sortMarkersArrays);
		} else {
			sorted.toShow = map.markers;
		}

		return sorted;
	}

/* ======================================================================
	Init
	===================================================================== */

	$('.map-canvas').each(function() {
		console.log("testing");

		render_map($(this));
	});

})(jQuery);
